import spinner from '../utils/rbata.spinner';
import addToCartService from '../services/rbata.addToCartService';
import theLookService from '../services/rbata.theLookService';
import notifyMeService from '../services/rbata.notifyMeService';
import page from '../utils/rbata.page';
import Breakpoints from 'breakpoints-js/src/breakpoints';
import mediaLazyLoad from '../utils/rbata.mediaLazyLoad';
import parallax from '../utils/rbata.parallax';
import detailPanel from "../pdp/rbata.detailpanel";
import productTileSlider from '../plp/rbata.tileSlider';

const shopTheLook = {
    shopTheLookWrapper:   undefined,
    filter:               undefined,
    shopTheLookItemClass: '.shop-the-look__item',
    allowedCategories:    undefined,
    stlModal:             undefined,
    lastFilterCategories: [],
    $body:                undefined,
    init() {
        this.shopTheLookWrapper = $('.shop-the-look');
        this.filter             = shopTheLook.shopTheLookWrapper.find('.shop-the-look__filters');
        this.allowedCategories  = shopTheLook.shopTheLookWrapper.data('allowed').split(',');
        this.stlModal           = $('#stlModal');
        this.$body              = $('body');
        this.bindEvents();
    },

    observeVideos() {
        const stlVideo = this.shopTheLookWrapper.find('video');

        const options = {
            rootMargin: '0px',
            threshold:  [0.1, 0.9]
        }

        let stlVideoObserver = new IntersectionObserver(this.observerCallback, options);

        $.each(stlVideo, (index, heroVideo) => {
            stlVideoObserver.observe(heroVideo);
        });
    },

    observerCallback: (entries) => {
        const intersectingVideoElement = $(entries[0].target);
        entries[0].isIntersecting ?
                intersectingVideoElement.trigger('play') :
                intersectingVideoElement.trigger('pause');
    },

    bindEvents() {
        if (this.shopTheLookWrapper.length) {
            /**
             * Click on item should summon modal with products.
             */
            this.shopTheLookWrapper.on('click', this.shopTheLookItemClass, this.showProductsFromLook);

            /**
             * Open mobile flyout
             */
            this.shopTheLookWrapper.on('click', '.shop-the-look__filter--mobile-trigger', this.showMobileFilterFlyout)

            /**
             * Detect filter changes
             */
            this.shopTheLookWrapper.on('change', 'input[type="checkbox"]', function (evt) {
                $(this).parents('.shop-the-look')
                       .find('.js-apply-facet-selection-stl')
                       .removeClass('d-none');
                shopTheLook.mirrorChoice($(this))
            });

            /**
             * Save filter changes
             */
            this.shopTheLookWrapper.on('click', '.js-apply-facet-selection-stl', function () {
                const $this       = $(this);
                const $rootParent = $this.parents('.shop-the-look');
                let tempCat       = [];
                $.each($rootParent.find('.shop-the-look__filter--desktop input[type="checkbox"]:checked'), function (index, checkbox) {
                    tempCat.push($(checkbox).val())
                });
                $rootParent.data('filter', tempCat);
                shopTheLook.filterLooksForFilter($rootParent);

                const $filter = $this.parents('.shop-the-look').find('.js-facet-clear-stl');

                tempCat.length ?
                        $filter.removeClass('d-none') :
                        $filter.addClass('d-none')

                $this.addClass('d-none');

                const $flyout = $(this).parents('.shop-the-look__filter-flyout');
                $flyout.find('.shop-the-look__filter-category-dropdown').removeClass('active');
                $flyout.find('.shop-the-look__filter-options').addClass('d-none');
            });

            /**
             * Clear filter
             */
            this.shopTheLookWrapper.on('click', '.js-facet-clear-stl', function (evt) {
                evt.stopPropagation();
                const $this       = $(this);
                const $rootParent = $this.parents('.shop-the-look');
                $rootParent.find(`input[type=checkbox]`)
                           .prop('checked', false)
                           .trigger('change');
                $rootParent.data('filter', []);
                shopTheLook.filterLooksForFilter($rootParent);
                $rootParent.find('.js-facet-clear-stl').addClass('d-none');
                $rootParent.find('.shop-the-look__filter-flyout').removeClass('facet__overlay--visible');
                $rootParent.find('.js-apply-facet-selection-stl').addClass('d-none');
                shopTheLook.closeMobileOverlay();
            });

            /**
             * Close filter overlay
             */
            this.shopTheLookWrapper.on('click', '.js-close-stl-facet-overlay', this.closeMobileOverlay);

            /**
             * Mobile filtering - flyout
             */
            this.shopTheLookWrapper.on('click', '.shop-the-look__filter-category-dropdown', shopTheLook.mobileDropdownAction);

            /**
             * Filter mouse on hover behaviour with proper timeout
             */

            this.shopTheLookWrapper
                .on('mouseenter', '.shop-the-look__filter-wrapper', function () {
                    shopTheLook.mouseEnterHoverTimeout = setTimeout(() => {
                        $(this).removeClass('hide');
                    }, 350);

                    if (shopTheLook.mouseLeaveHoverTimeout) {
                        clearTimeout(shopTheLook.mouseLeaveHoverTimeout);
                        shopTheLook.mouseLeaveHoverTimeout = undefined;
                    }
                })
                .on('mouseleave', '.shop-the-look__filter-wrapper', function () {
                    shopTheLook.mouseLeaveHoverTimeout = setTimeout(() => {
                        $(this).addClass('hide');
                    }, 350);

                    if (shopTheLook.mouseEnterHoverTimeout) {
                        clearTimeout(shopTheLook.mouseEnterHoverTimeout);
                        shopTheLook.mouseEnterHoverTimeout = undefined;
                    }
                });

            /**
             * Hook in when modal became hidden, then call cleanup method
             */
            this.stlModal.on('hidden.bs.modal', this.cleanupModal);

            /**
             * Close all flyouts if breakpoint changed
             */
            Breakpoints.on('desktop', {
                enter: () => {
                    $('.js-close-stl-facet-overlay').trigger('click');
                }
            });
        }
    },

    initCartHandlers() {
        /**
         * add to cart functionality. If no size is selected show an error message
         */
        this.$body.on('click', '.js-stl__add-to-cart', evt => {
            evt.preventDefault();
            const currentTarget = evt.currentTarget;
            const dataset       = currentTarget.dataset;
            if (dataset.code === '') {
                theLookService.clearLocalErrorMessages(currentTarget).call(this);
                theLookService.renderLocalErrorMessages(currentTarget).call(this, [dataset.message]);
                return;
            }
            addToCartService.addToCart(dataset.url, dataset.code, theLookService.clearLocalErrorMessages(currentTarget),
                    theLookService.renderLocalErrorMessages(currentTarget));
        });

        /**
         * Update all related information on change of a size
         */
        this.$body.on('click', '.js-stl__select-size', (evt) => {
            evt.preventDefault();
            const currentTarget = evt.currentTarget;

            theLookService.performSizeChange(currentTarget);
        });

        /**
         * Delegate notifyMe
         */
        this.$body.on('click', '.js-stl__notifyme', evt => {
            evt.preventDefault();
            const dataset = evt.currentTarget.dataset;
            if (dataset.code !== '') {
                notifyMeService.showNotifyMeModal(dataset.code);
            } else {
                theLookService.clearLocalErrorMessages(evt.currentTarget).call(this);
                theLookService.renderLocalErrorMessages(evt.currentTarget).call(this, [dataset.message]);
            }
        });
    },

    /**
     * This method decides which product to show based on category
     * @param $filterRootElem
     * @param cats
     */
    filterLooksForFilter($filterRootElem) {
        const totalFilters = $filterRootElem.data('filter').length;
        $filterRootElem.find('.shop-the-look__filter-counter').html(totalFilters === 0 ? '' : totalFilters);
        if (totalFilters) {
            $filterRootElem.find(`.shop-the-look__item`)
                           .addClass('shop-the-look__item--hidden');
            $.each($filterRootElem.data('filter'), function (index, category) {
                $filterRootElem.find(`.shop-the-look__item[data-category=${category}]`)
                               .removeClass('shop-the-look__item--hidden');
            });
        } else {
            $filterRootElem
                    .find(`.shop-the-look__item`)
                    .removeClass('shop-the-look__item--hidden');
        }
        parallax.onScrollAndLoad();
    },

    mobileDropdownAction() {
        const $this = $(this);
        $this.toggleClass('active');
        $this.siblings('.shop-the-look__filter-options')
             .toggleClass('d-none');
    },

    showMobileFilterFlyout() {
        $(this).parent()
               .children('.shop-the-look__filter-flyout')
               .addClass('facet__overlay--visible');
        page.addBackdrop(true, shopTheLook.$body);
    },

    /**
     * Sync overlay and desktop filter checkboxes
     * @param currentCheckbox
     */
    mirrorChoice(currentCheckbox) {
        currentCheckbox.parents('.shop-the-look')
                       .find(`input[value="${currentCheckbox.val()}"]`)
                       .prop('checked', currentCheckbox.is(':checked'));
    },

    closeMobileOverlay(evt) {
        if (evt) {
            evt.stopPropagation();
        }
        const $flyout = $(this).parents('.shop-the-look__filter-flyout');
        $flyout.removeClass('facet__overlay--visible');
        $flyout.find('.shop-the-look__filter-category-dropdown').removeClass('active');
        $flyout.find('.shop-the-look__filter-options').addClass('d-none');
        page.addBackdrop(false, shopTheLook.$body);
    },

    /**
     * Preselect watcher, if there is param `gender` with valid value, this method will preselect all filters
     */
    checkPreSelection() {
        const urlParams         = new URLSearchParams(window.location.search),
              genderParam       = urlParams.get('gender'),
              preselectCategory = shopTheLook.allowedCategories.find(elem => elem === genderParam);

        if (genderParam != null && preselectCategory !== undefined) {
            shopTheLook.shopTheLookWrapper
                       .find(`input[type=checkbox][value=${genderParam}]`)
                       .prop('checked', true)
            shopTheLook.shopTheLookWrapper
                       .find('.js-apply-facet-selection-stl')
                       .trigger('click');
        }
    },

    /**
     * Trigger for modal window and
     * @param evt
     */
    showProductsFromLook(evt) {
        const $this       = $(this),
              lookCode    = $this.data('code'),
              orderNumber = $this.data('orderNumber');
        shopTheLook.fetchStlProducts(lookCode, orderNumber);
    },

    /**
     * Fires ajax for fetching product, needs look code as parameter. Look code is case sensitive
     * @param lookCode
     */
    fetchStlProducts(lookCode, orderNumber) {
        const stlProductsUrl = `${window.location.origin}${alphatauri.config.encodedContextPath}/stlproduct/overlay/${lookCode}`;
        const $stlProducts   = $.get(stlProductsUrl);
        spinner.visibility(true);

        $stlProducts.then((response) => {
            shopTheLook.digestAndRenderStlProducts(response, orderNumber);
            shopTheLook.stlModal.modal('show');
            spinner.visibility(false);
            mediaLazyLoad.refreshLazyLoad();
            detailPanel.preselectFirstAvailableSize('.stl__actions-size','.js-stl__select-size');
            productTileSlider.reInit();

        })
    },

    /**
     * Handles response of fetchStlProducts() method. Needs response html
     * @param response
     */
    digestAndRenderStlProducts(response, orderNumber) {
        const lookTitle  = $(response).data('look-title');
        const modalTitle = orderNumber ? `${lookTitle} &ndash; N&ordm;&nbsp;${orderNumber}` : `${lookTitle}`;

        // Apply popup title from look
        this.stlModal
            .find('.modal-title')
            .html(modalTitle);
        // Take modal spread param
        this.stlModal
            .find('.modal-dialog')
            .addClass($(response).data('modal-spread'));
        // Just insert response inside modal body
        shopTheLook.stlModal
                   .find('.modal-body')
                   .html(response);
    },

    /**
     * Cleanup classes and content
     */
    cleanupModal() {
        shopTheLook.stlModal
                   .find('.modal-dialog')
                   .removeClass('wide');
    },
    /**
     * Necessary, because function in detailPanel module was "optimized"
     */
    preselectFirstAvailableSize(wrapper, button) {
        const buttonSizeWrapper = this.$body.find(wrapper);
        buttonSizeWrapper.map((index, wrapper) => {
            const $wrapper         = $(wrapper);
            const firstAvailable   = $wrapper.find('button[data-out-of-stock=false]');
            const smallestNotifyMe = $wrapper.find('button[data-notify-me=true]');

            if ($wrapper.length > 0) {
                if (firstAvailable.length > 0) {
                    $(firstAvailable[0]).trigger('click');
                } else if (smallestNotifyMe.length > 0) {
                    $(smallestNotifyMe[0]).trigger('click');
                } else {
                    $($wrapper.find(button)[0]).trigger('click');
                }
            }
        });
    },
}

$(() => {
    if ($('.shop-the-look').length) {
        shopTheLook.init();
        shopTheLook.initCartHandlers();
        shopTheLook.checkPreSelection();
        // shopTheLook.observeVideos();
    }
});

export default shopTheLook;
